import React from "react";
import { makeStyles } from "@material-ui/core";
import { Typography, Paper } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  cardHeader: {
    marginTop: 22,
    marginBottom: 21,
    marginLeft: 21,
    marginRight: 21,
    textAlign: "justify",
  },

  cardRule: {
    color: theme.palette.primary.main,
    opacity: 0.3,
    marginBottom: 15,
  },
}));

const ReportsCard = ({ cardLabel, children, ...other }) => {
  const classes = useStyles();

  return (
    <Paper square variant="outlined" {...other}>
      <Typography className={classes.cardHeader} variant="h2">
        {cardLabel}
      </Typography>
      <hr className={classes.cardRule} />
      {children}
    </Paper>
  );
};

export default ReportsCard;
